import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

export function atLeastOneRequiredValidator(fields: string[]): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (group === null || !(group.parent instanceof FormGroup)) return null;
    const parent = group.parent;
    const hasValue = fields.some(field => {
      const value = parent.get(field)?.value;
      return value !== null && value !== undefined && value !== '' && value > 0;
    });

    fields.forEach(field => {
      const control = parent.get(field);
      if (control) {
        if (hasValue) {
          control.setErrors(null); // Clear errors if at least one field has a value
        } else {
          control.setErrors({ atLeastOneRequired: true }); // Set error if no fields have values
        }
      }
    });
    return hasValue ? null : { atLeastOneRequired: true };
  };
}
